import { Area } from './area';
import {
  DateFilterCondition,
  NumberFilterCondition,
  TextFilterCondition,
} from './filters';

export enum ValidationCriteria {
  List = 'List',
  CellRange = 'Cell Range',

  Checkbox = 'Checkbox',
  Files = 'Files',

  IconSets = 'Icon Sets',

  Number = 'Number',
  Text = 'Text',
  TextLength = 'Text Length',
  Date = 'Date ',
}

interface ConditionBase<Condition, DataType> {
  condition: Condition;
  firstValue?: DataType;
  secondValue?: DataType;
}

export type ValidationFilterCondition =
  | NumberFilterCondition
  | TextFilterCondition
  | DateFilterCondition;

export interface NumberValidation
  extends ConditionBase<NumberFilterCondition, string> {
  criteria: ValidationCriteria.Number;
}

export interface TextValidation
  extends ConditionBase<TextFilterCondition, string> {
  criteria: ValidationCriteria.Text;
}

export interface TextLengthValidation
  extends ConditionBase<NumberFilterCondition, string> {
  criteria: ValidationCriteria.TextLength;
}

export interface DateValidation
  extends ConditionBase<DateFilterCondition, string> {
  criteria: ValidationCriteria.Date;
}

export interface ListValidation {
  criteria: ValidationCriteria.List;
  list: string[];
  showList?: boolean;
}

export interface CellRangeValidation {
  criteria: ValidationCriteria.CellRange;
  showList?: boolean;
}

export interface CheckboxValidation {
  criteria: ValidationCriteria.Checkbox;
  useCustomCellValues?: boolean
  checkedValue: string,
  uncheckedValue: string 
}

export interface FilesValidation {
  criteria: ValidationCriteria.Files;
}

export enum IconSetCategory {
  Delivery = 'Delivery',
  PaymentInflow = 'Payment',
  // PaymentOutflow = 'Payment Outflow',
  Priority = 'Priority',
  Rating = 'Rating',
  // Status = 'Status',
  // HealthStatus = 'Health Status',
  Weather = 'Weather',
  // Progress = 'Progress',
  // Rating = "Rating",
  // Security = 'Security',
  // Location = 'Location',
  // Communication = 'Communication',
  Custom = 'Custom',
}


export enum IconSetType {
  Single = "single",
  Multiple = "multiple",
  Progressive = "progressive"
}

// export interface ListMap {
//   [key: string]: string;
// }

export interface IconSetsValidation {
  criteria: ValidationCriteria.IconSets;
  category: IconSetCategory;
  setType: IconSetType
  useCustomIcons?: boolean;
  showList?: boolean
  // iconsMap: ListMap;
}

export type ValidationRuleCriteria =
  | NumberValidation
  | TextValidation
  | TextLengthValidation
  | DateValidation
  | ListValidation
  | CellRangeValidation
  | CheckboxValidation
  | FilesValidation
  | IconSetsValidation;

export enum ValidationInvalidInputAlert {
  Reject = 'Reject',
  Warning = 'Warning',
}

export interface ValidationRuleSettings {
  ignoreBlanks: boolean;
  showHelpText: boolean;
  helpText: string;
  showAlertWhenInvalid: boolean;
  invalidAlert: ValidationInvalidInputAlert;
  invalidMessage: string;
  markInvalidContent: boolean;
}

export interface ValidationRuleBase {
  id: string;
  areas: Area[];
}
export type ValidationRule = ValidationRuleBase &
  Partial<ValidationRuleSettings> &
  ValidationRuleCriteria;

export interface ValidationRules {
  [id: string]: ValidationRule;
}

export interface ValidationAddressMap {
  [address: string]: string;
}

export type ValidationMatrix = string[][];

export interface SheetDataValidation {
  dataValidationMatrix: ValidationMatrix;
  dataValidationsMap: ValidationAddressMap;
  dataValidationRules: ValidationRules;
}
